var map = {
	"./banner-anhui.jpg": 168,
	"./banner-fujian.jpg": 169,
	"./banner-guangdong.jpg": 170,
	"./banner-guangxi.jpg": 171,
	"./banner-hunan.jpg": 172,
	"./banner-shanxi.jpg": 173,
	"./banner-sichuan.jpg": 174,
	"./banner-yunnan.jpg": 175
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;


//////////////////
// WEBPACK FOOTER
// ./src/images/active ^\.\/banner\-.*\.jpg$
// module id = 72
// module chunks = 1